import { KYMW6600Component } from './kymw6600.component';

/**
 * 特別指示書画面の値を管理するクラス
 *
 * @export KYMW6600Model
 * @class KYMW6600Model
 */
export class KYMW6600Model {

  kymw6600Component: KYMW6600Component;

  /** ファイル名 */
  public fileName = '';
  /** 指示書区分 */
  public indicationDiv: string = <string>'';
  /** 受注コード */
  public orderCode: string = <string>'';
  /** 部門 */
  public classCode: string = <string>'';
  /** 媒体 */
  public mediumType: string = <string>'';
  /** バイヤーコード */
  public buyerCode: string = <string>'';

}
